<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import { addAddOn } from "../../../api/services/addon.service";
import { getS3SingedUrl } from "../../../api/services/general.service";
import { newExtraObject } from "./extra-controller";
import Multiselect from "vue-multiselect";
import ImageCroperModel from "../../../components/models/image-crop.vue";

export default {
  props: {
    visible: Boolean,
    closeable: Boolean,
  },
  components: {
    Multiselect,
    "image-cropper-model": ImageCroperModel,
  },
  data() {
    return {
      pricingTypes: [
        { name: "Einheits Preisbildung", value: "UNIT" },
        { name: "Gesamte Preisgestaltung", value: "ENTIRE" },
      ],
      vatPercentages: [
        { name: "5%", value: 5 },
        { name: "10%", value: 10 },
        { name: "20%", value: 20 }
      ],
      extraTitle: null,
      extraDescription: null,
      extraTitleImageURL: null,
      extraPricingType: null,
      extraVatPercentage: null,
      extraPrice: null,
      isUploadingProcessing: false,
      isUploadSuccess: false,
      isUploadFailed: false,
      isFormSubmited: false,
      showExtraImageCropModel: false,
      extraImageFileToCrop: null,
      croppedExtraImage: null,
    };
  },
  validations: {
    extraTitle: { required },
    extraDescription: { required },
    extraPricingType: { required },
    extraVatPercentage: { required },
    extraPrice: { required },
  },
  computed: {
    showModal: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {},
  methods: {
    async clickCreateSubpackageButton() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isFormSubmited = true;
        this.isUploadingProcessing = true;

        let newExtraObject_Pass = new newExtraObject();
        newExtraObject_Pass.extraTitle = this.extraTitle;
        newExtraObject_Pass.extraDescription = this.extraDescription;
        newExtraObject_Pass.extraPricingType = this.extraPricingType.value;
        newExtraObject_Pass.extraPrice = Number(this.extraPrice);
        newExtraObject_Pass.extraVatPercentage = this.extraVatPercentage.value;

        if (this.croppedExtraImage) {
          const extraImageFile = this.$refs.extraImageInput.files[0];
          const croppedExtraImage = this.croppedExtraImage;
          const finalExtraImageToPass = await new Promise(function(resolve) {
            return croppedExtraImage.toBlob(resolve, extraImageFile.type);
          });
          const fileName = extraImageFile.name;
          let getUploadedImageURL = await getS3SingedUrl(fileName);

          let getFileUploadResponse = await axios.put(
            getUploadedImageURL.signedUrl,
            finalExtraImageToPass
          );

          if (getFileUploadResponse) {
            let fileBaseUrl =
              "https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";
            newExtraObject_Pass.extraTitleImageURL = fileBaseUrl + fileName;
          }
        }

        let extraCreationSuccess = await addAddOn(newExtraObject_Pass);

        if (extraCreationSuccess) {
          this.isUploadingProcessing = false;
          this.isUploadSuccess = true;
        } else if (!extraCreationSuccess) {
          this.isUploadingProcessing = false;
          this.isUploadFailed = true;
        }
      } else {
        console.log("Validation Error"); //eslint-disable-line
      }
    },
    extraImageSelected() {
      const imagePreviewCanvers = this.$refs.extraImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );

      const extraImageFile = this.$refs.extraImageInput.files[0];
      this.openCorpExtraImageModel(extraImageFile);
    },
    openCorpExtraImageModel(extraImageFile) {
      this.extraImageFileToCrop = extraImageFile;
      this.showExtraImageCropModel = true;
    },
    setCroppedImageToPreview(croppedImage) {
      const imagePreview = this.$refs.extraImagePreview;
      const imagePreviewCanvers = this.$refs.extraImageCanvas;
      if (imagePreview && imagePreviewCanvers.getContext) {
        const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
        imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
      }
      this.croppedExtraImage = croppedImage;
      this.showExtraImageCropModel = false;
    },
    clickRemoveExtraImage() {
      this.croppedExtraImage = null;
      this.extraTitleImageURL = null;
      const imagePreviewCanvers = this.$refs.extraImageCanvas;
      const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
      imagePreviewCanversContext.clearRect(
        0,
        0,
        imagePreviewCanvers.width,
        imagePreviewCanvers.height
      );
    },
    clickCloseButton() {
      this.$emit("reload");
    },
  },
};
</script>

<template>
  <!-- Edit Company Model-->
  <b-modal
    v-model="showModal"
    :title="this.$i18n.t('extras.createExtra.title')"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    scrollable
  >
    <div class="row" v-if="!isFormSubmited">
      <!-- Extra Image -->
      <div class="col-md-3 mb-4">
        <div class="avatar-md mr-4">
          <span ref="extraImagePreview" class="extra-image-preview-after-crop">
            <canvas
              id="extraImageCanvas"
              ref="extraImageCanvas"
              height="120"
              width="120"
            ></canvas>
            <span
              v-if="!this.croppedExtraImage"
              class="avatar-title bg-white"
              style="margin-left: -120px"
            >
              <img
                src="https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/images/ms-sissi-extra-default.png"
                class="rounded-0"
                alt
                height="120"
              />
            </span>
          </span>
        </div>
      </div>
      <div class="col-md-9 mb-4">
        <div class="">
          <input
            id="extraImageInput"
            ref="extraImageInput"
            type="file"
            name="file"
            accept="image/*"
            @change="extraImageSelected()"
            style="width: 0.1px; opacity: 0; z-index: -1"
          />
          <div>
            <label
              for="extraImageInput"
              class="text-info ml-3"
              style="cursor: pointer"
            >
              {{ $t("extras.createExtra.form.uploadNewImage") }}
            </label>
            <label class="ml-2" v-if="this.croppedExtraImage"> &#8226; </label>
            <label
              class="text-info ml-2"
              @click="clickRemoveExtraImage()"
              style="cursor: pointer"
              v-if="this.croppedExtraImage"
            >
              {{ $t("extras.createExtra.form.removeImage") }}
            </label>
          </div>
          <div class="ml-3 text-mute">
            <small>
              {{ $t("extras.createExtra.form.imageSupportText") }}
              <br />
              <b> Bildgröße 500px * 500px </b>
            </small>
          </div>
        </div>
      </div>
      <!-- Extra Title -->
      <div class="col-md-12 mt-5">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.titleLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="extraTitle"
                class="badge position-absolute"
                :class="{
                  'badge-light': extraTitle.length !== 50,
                  'badge-danger': extraTitle.length === 50,
                }"
              >
                {{ extraTitle.length }} / 50
              </p>
            </span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="extraTitle"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.titlePlaceholder')
              "
              :maxlength="50"
              :class="{ 'is-invalid': $v.extraTitle.$error }"
            ></b-form-input>
            <div v-if="$v.extraTitle.$error" class="invalid-feedback">
              <span v-if="$v.extraTitle.$error && !$v.extraTitle.required">{{
                $t("extras.createExtra.form.titleRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra Descrtiption -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.descriptionLabel") }}
            <span class="text-danger">*</span>
            <span class="ml-2">
              <p
                v-if="extraDescription"
                class="badge position-absolute"
                :class="{
                  'badge-light': extraDescription.length !== 120,
                  'badge-danger': extraDescription.length === 120,
                }"
              >
                {{ extraDescription.length }} / 120
              </p>
            </span>
          </label>
          <textarea
            v-model="extraDescription"
            class="form-control"
            name="textarea"
            rows="4"
            :maxlength="120"
            :placeholder="
              this.$i18n.t('extras.createExtra.form.descriptionPlaceholder')
            "
            :class="{ 'is-invalid': $v.extraDescription.$error }"
          ></textarea>
          <div v-if="$v.extraDescription.$error" class="invalid-feedback">
            <span
              v-if="$v.extraDescription.$error && !$v.extraDescription.required"
              >{{ $t("extras.createExtra.form.descriptionRequiredMsg") }}</span
            >
          </div>
        </div>
      </div>
      <!-- Extra Pricing Type -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.pricingTypeLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <multiselect
              track-by="name"
              label="name"
              v-model="extraPricingType"
              :options="pricingTypes"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.pricingTypePlaceholder')
              "
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}</template
              >
            </multiselect>
            <div v-if="$v.extraPricingType.$error" class="invalid-feedback">
              <span
                v-if="
                  $v.extraPricingType.$error && !$v.extraPricingType.required
                "
                >{{
                  $t("extras.createExtra.form.pricingTypeRequiredMsg")
                }}</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra vat Percentage -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.vatPercentageLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <multiselect
              label="name"
              v-model="extraVatPercentage"
              :options="vatPercentages"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.vatPercentagePlaceholder')
              "
            >
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.name }}</template
              >
            </multiselect>
            <div v-if="$v.extraVatPercentage.$error" class="invalid-feedback">
              <span
                v-if="
                  $v.extraVatPercentage.$error &&
                    !$v.extraVatPercentage.required
                "
                >{{
                  $t("extras.createExtra.form.vatPercentageRequiredMsg")
                }}</span
              >
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Extra Price -->
      <div class="col-md-12">
        <div class="mb-4">
          <label>
            {{ $t("extras.createExtra.form.priceLabel") }}
            <span class="text-danger">*</span>
          </label>
          <b-form-group>
            <b-form-input
              v-model="extraPrice"
              :placeholder="
                this.$i18n.t('extras.createExtra.form.pricePlaceholder')
              "
              :class="{ 'is-invalid': $v.extraPrice.$error }"
              type="number"
            ></b-form-input>
            <div v-if="$v.extraPrice.$error" class="invalid-feedback">
              <span v-if="$v.extraPrice.$error && !$v.extraPrice.required">{{
                $t("extras.createExtra.form.priceRequiredMsg")
              }}</span>
            </div>
          </b-form-group>
        </div>
      </div>
      <!-- Save Button -->
      <div class="col-md-12">
        <div class="">
          <b-button variant="success" @click="clickCreateSubpackageButton()">
            <i class="bx bxs-check-circle mr-1"></i>
            {{ $t("general.buttons.create") }}</b-button
          >
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <!-- Uploading Processing -->
      <div class="col-md-12 text-center" v-if="isUploadingProcessing">
        <b-spinner
          style="width: 5rem; height: 5rem"
          class="m-2"
          variant="warning"
          role="status"
        ></b-spinner>
        <h5 class="mt-3">
          {{ $t("extras.createExtra.form.uploadProcessingTitle") }}
        </h5>
        <p class="mt-3">
          {{ $t("extras.createExtra.form.uploadProcessingText") }}
        </p>
      </div>
      <!-- Upload Success -->
      <div class="col-md-12 text-center" v-if="isUploadSuccess">
        <i class="bx bx-check-circle bx-tada text-success display-1"></i>
        <h5 class="mt-3">
          {{ $t("extras.createExtra.form.uploadSuccesTitle") }}
        </h5>
        <p class="mt-3 mb-3">
          {{ $t("extras.createExtra.form.uploadSuccessText") }}
        </p>
        <b-button variant="warning" @click="clickCloseButton()">
          <i class="bx bxs-x-circle mr-1"></i>
          {{ $t("general.buttons.close") }}</b-button
        >
      </div>
      <!-- Upload Failed -->
      <div class="col-md-12 text-center" v-if="isUploadFailed">
        <i class="bx bx-x-circle bx-tada text-danger display-1"></i>
        <div class="mt-3">
          {{ $t("extras.createExtra.form.uploadFailedTitle") }}
        </div>
        <p class="mt-3">
          {{ $t("extras.createExtra.form.uploadFailedText") }}
        </p>
      </div>
    </div>

    <!-- Image Cropper Model -->
    <image-cropper-model
      v-if="this.showExtraImageCropModel === true"
      :visible="showExtraImageCropModel"
      @close="showExtraImageCropModel = false"
      :imageFile="extraImageFileToCrop"
      @apply="setCroppedImageToPreview"
    />
  </b-modal>
</template>

<style scoped>
.extra-image-preview-after-crop {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: none;
  width: 120px;
  height: 120px;
  padding: 0;
  margin: 0;
}
</style>
